module.exports = __webpack_public_path__ + "img/越野小飞车.ccdc5700.png";